import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import Global from '../../../../store/global-selectors';
import { Footer } from './footer';
import { LabelBatchProcessing } from './index';
import { BatchStatusIdService } from './batch-status-id-service';
import { clearLabelBatchStatusModalBatches } from '../../../../store/batches/label-batch-status-modal/batches.label-batch-status-modal.actions';

import sharedStyle from '../style.module.less';

const messages = defineMessages({
  processingTitle: {
    description: 'batchProcessingModal.processingTitle',
    defaultMessage: 'Label Batch Status: Processing',
    id: 'JQdgrB',
  },
  generatingTitle: {
    description: 'batchProcessingModal.generatingTitle',
    defaultMessage: 'Label Batch Status: Generating',
    id: '7mPlQl',
  },
  processedTitle: {
    description: 'batchProcessingModal.processedTitle',
    defaultMessage: 'Label Batch Status: Processed',
    id: 'wjdfnz',
  },
});

const getTitle = (isProcessing, isGenerating) => {
  const generatingMessage = isGenerating ? messages.generatingTitle : messages.processingTitle;
  const statusMessage = isProcessing ? generatingMessage : messages.processedTitle;
  return <FormattedMessage {...statusMessage} />;
};

export const LabelBatchProcessingModalContainer = (props) => {
  const { modalFrameworkMethods, batchIds } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    return () => dispatch(clearLabelBatchStatusModalBatches());
  }, [dispatch]);
  const { closeModal } = modalFrameworkMethods;
  const labelBatchStatusModalBatches = useSelector(Global.selectBatchesLabelBatchStatusModalLabelBatchStatusModalBatches);
  const batches = labelBatchStatusModalBatches.filter((b) => batchIds.includes(b.batchId));
  const isProcessing = batches.length === 0 || batches.some((b) => BatchStatusIdService.isProcessing(b.statusId));
  const isGenerating = batches.every((b) => BatchStatusIdService.isGenerating(b.statusId));
  const isCompleteSuccess = !!batches.length && batches.every((b) => !isProcessing && b.completed === b.total);
  return (
    <React.Fragment>
      <ModalHeader className={sharedStyle['batch-processing-modal-header']} closeModal={closeModal}>
        {getTitle(isProcessing, isGenerating)}
      </ModalHeader>
      <ModalBody className={sharedStyle['batch-processing-modal-body']}>
        {batchIds.map((batchId) => {
          return (
            <div key={batchId}>
              <LabelBatchProcessing batchId={batchId} modalFrameworkMethods={modalFrameworkMethods} />
            </div>
          );
        })}
      </ModalBody>
      <Footer closeModal={closeModal} isCompleteSuccess={isCompleteSuccess} isProcessing={isProcessing} />
    </React.Fragment>
  );
};

LabelBatchProcessingModalContainer.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  batchIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};
